import React from 'react';
import { MyListView } from '../components/my-list-view';
import { SubscribeBand } from '../components/subscribe-band';
import { usePageTitle } from '../hooks/usePageTitle';

export default function WatchlistPage() {
  usePageTitle('Watchlist · Kast', 'Your curated watchlist of movies and series on Kast.');
  return (
    <div className="flex flex-col min-h-screen">
      <MyListView />
      <SubscribeBand />
    </div>
  );
}
